import { Loader2, WifiOff } from "lucide-react";
import { Button } from "@/shared/components/ui/button";
import type { RealtimeStatus } from "../api/splits.realtime";

// Two-state connection feedback for the live board:
// - reconnecting: subtle, non-blocking — edits stay enabled while auto-reconnect retries.
// - disconnected (terminal): a banner prompting a reload; edit gating is handled in SplitsBoard.
export function ConnectionBanner({ status }: { status: RealtimeStatus }) {
  if (status === "reconnecting") {
    return (
      <div className="mb-2 flex items-center gap-2 text-xs text-muted-foreground">
        <Loader2 className="size-3.5 animate-spin" />
        Återansluter…
      </div>
    );
  }

  if (status === "disconnected") {
    return (
      <div className="mb-2 flex items-center gap-3 rounded-md border border-destructive/50 bg-destructive/10 px-3 py-2 text-sm text-foreground">
        <WifiOff className="size-4 shrink-0 text-destructive" />
        <span className="flex-1">
          Frånkopplad — ladda om för att fortsätta.
        </span>
        <Button
          size="sm"
          variant="outline"
          onClick={() => window.location.reload()}
        >
          Ladda om
        </Button>
      </div>
    );
  }

  return null;
}
